<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  data() {
    return {
      opportunity: null,
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob,
  },
};
</script>

<template>
  <div class="collection">
    <div class="container">
      <h1>sobre a individual</h1>
      <p>
        Há trinta e cinco anos a Individual é a solução para o guarda-roupa
        masculino. Estamos presentes em mais de mil multimarcas espalhadas por
        todo país, onde oferecemos roupas para todas as ocasiões do dia a dia do
        homem brasileiro. Nossos produtos proporcionam conforto e fazem todos se
        sentirem bem.
      </p>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.collection {
  margin-top: 4rem;
}
h1 {
  font-size: 1.9rem;
  text-transform: uppercase;
  font-weight: 500;
  color: #000;
}
p {
  font-size: 1.2rem;
  color: #000;
  margin-top: 1rem;
  border-bottom: 2px solid theme-color(primary);
  padding-bottom: 2rem;
  margin-bottom: 1.5rem;
}
</style>